import styled from "styled-components";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";
import { calcRem, getSummaryCardStyle } from "styles/theme";

export const Item = styled.li`
  width: 100%;
  height: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};
  ${FLEX.FlexStartStart};
  flex: 1;
  flex-direction: column;
  gap: 10px;
  height: 100%;

  .bold {
    font-weight: 500;
    font-size: ${calcRem(20)};
  }

  .content {
    width: 100%;
    ${({ theme }) => getSummaryCardStyle(theme)}
    padding: 18px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const Top = styled.div`
  flex: 4;
  gap: 8px;
  ${FLEX.FlexStartStart};
  flex-direction: column;
  position: relative;
`;

export const Bottom = styled.div`
  flex: 1;
  ${FLEX.FlexBetweenCenter};
  flex-direction: row !important;
  width: 100%;
  padding: 12px !important;
`;

export const RecorderType = styled.div`
  width: 100%;
  height: 100%;
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 8px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ theme }) =>
    theme.value === "light" ? COLORS.WHITE : COLORS.PRIMARY3};
  z-index: 1;
  border-radius: 5px;
`;

export const Title = styled.div<{ isDetail?: boolean }>`
  width: 100%;
  ${FLEX.FlexBetweenCenter};
  flex: 0 0 auto;
  cursor: move;

  .name {
    flex: 1;
    ${FLEX.FlexStartCenter}
  }

  .detail {
    font-size: ${calcRem(13)};
    /* color: ${({ theme }) => theme.COLORS.WHITE}80; */
  }

  ${({ isDetail, theme }) =>
    isDetail &&
    `
    padding-bottom: 6px;
    border-bottom: 1px solid #7883A1;
  `}
`;

export const Increase = styled.div<{ color: string }>`
  ${FLEX.FlexStartCenter};
  gap: 4px;
  color: ${({ color }) => color};

  .number {
    font-size: ${calcRem(28)};
  }
`;

export const BottomInner = styled.ul`
  ${FLEX.FlexAroundCenter};
  width: 100%;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
`;
export const DetaiItem = styled.li<{ isVmax?: boolean; isRecorder?: boolean }>`
  text-align: center;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  flex: 1;
  min-height: 36px;
  gap: 8px;
  ${({ isVmax }) =>
    isVmax &&
    `
    .links {
      display: none;
    }
    &:hover {
      > .detail-title,
      > .detail-value {
        display: none;
      }
      .links {
        flex: 1;
        ${FLEX.FlexCenterCenter};
        flex-direction: column;
        gap: 10px;
      }
    }
  `}
  * {
    font-weight: 500;
  }

  .detail-title {
    color: ${COLORS.TEXT};
    color: ${({ theme }) =>
      theme.value === "light" ? COLORS.TEXT : COLORS.LIGHTGRAY};
    font-size: ${calcRem(14)};
    ${({ isRecorder }) =>
      isRecorder &&
      `
      cursor: pointer;
      text-decoration: underline;
    `}
  }
`;

export const ChartWrapper = styled.div`
  width: 100%;
  height: 40%;
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const DetailWrapper = styled.div`
  /* border-bottom: 1px solid #7883a1; */
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  .ant-table-cell,
  .ant-table-tbody > tr > td:first-child,
  .ant-table-thead > tr > th:first-child {
    padding-left: 2px !important;
  }

  .total-count {
    font-weight: 500;
    text-align: right;
    font-size: ${calcRem(18)};
    color: ${COLORS.BUTTONS2};
    + .total-count {
      margin-top: 15px;
    }
  }
  .total-count.alert {
    color: ${COLORS.RED};
  }
`;

export const ColumnTitle = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  font-weight: 500;
  white-space: nowrap;

  .level-circle {
    width: 22px;
    height: 22px;
    max-width: 22px;
    max-height: 22px;
    min-width: 22px;
    min-height: 22px;
    font-size: ${calcRem(10)};
  }
`;
